export default __webpack_public_path__ + "static/media/キール.aed56a1d.PNG";